import { switchMap, mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { collectorApiService } from '@cbridge-packages/api-collector';
import { PerformanceMetricsAction } from '../performanceMetrics.action';
import { PerformanceMetricsTranslator } from '../performanceMetrics.translator';

export const loadPerformanceMetricsEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(PerformanceMetricsAction.load.started),
  switchMap(() => {
    return collectorApiService.getPerformanceMetrics().pipe(
      mergeMap((response) => {
        const result = PerformanceMetricsTranslator.fromApi(response);
        return [
          PerformanceMetricsAction.load.done({ result }),
        ];
      }),
      catchApiError((error) => {
        return [
          PerformanceMetricsAction.load.failed({ error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
